<div class="remove-attachment-dialog-container">
    <div class="remove-attachment-dialog-header-container">
        <div>  <p class="remove-attachment-dialog-header-text remove-attachment-item-section-headers">REMOVE ATTACHMENT</p></div>
        <div><p class="remove-attachment-dialog-sub-heading">Are you sure you want to remove this attachment?</p></div>
    </div>

    <div class="order-attachment-btn-dialog-container">

        <button class="cancel-attachment-dialog-btn" mat-flat-button type="button" (click)="cancelRemovingAttachment()">
            <div class="cancel-alt-btn-content">
                <span><p class="cancel-alt-btn-text">CANCEL</p></span>
            </div>
        </button>

        <button class="remove-order-attachment-btn" mat-flat-button type="button"
                (click)="deleteOrderAttachment()">
            <div class="remove-order-attachment-btn-content">
                <span><p class="remove-order-attachment-btn-text">REMOVE ATTACHMENT</p></span>
            </div>
        </button>
    </div>

</div>

